import React from 'react';
import { Card, CardContent, Typography, Box, CircularProgress } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

interface MetricCardProps {
  title: string;
  value: number | string;
  icon: SvgIconComponent;
  color: string;
  loading?: boolean;
  onClick?: () => void;
  subtitle?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon: Icon,
  color,
  loading = false,
  onClick,
  subtitle
}) => {
  return (
    <Card
      sx={{
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #e2e8f0',
        borderLeft: `4px solid ${color}`,
        '&:hover': onClick ? {
          transform: 'translateY(-2px)',
          boxShadow: '0 8px 25px rgba(0,0,0,0.12)',
        } : {},
      }}
      onClick={onClick}
    >
      <CardContent sx={{ p: 3 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box flex={1}>
            <Typography
              variant="body2"
              color="#64748b"
              sx={{ mb: 1, fontWeight: 500, textTransform: 'uppercase', fontSize: '0.75rem' }}
            >
              {title}
            </Typography>
            
            {loading ? (
              <Box display="flex" alignItems="center" gap={1}>
                <CircularProgress size={16} sx={{ color }} />
                <Typography variant="body2" color="#64748b">Loading...</Typography>
              </Box>
            ) : (
              <>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 700,
                    color: '#1e293b',
                    mb: subtitle ? 0.5 : 0
                  }}
                >
                  {value}
                </Typography>
                {subtitle && (
                  <Typography
                    variant="body2"
                    color="#64748b"
                    sx={{ fontSize: '0.875rem' }}
                  >
                    {subtitle}
                  </Typography>
                )}
              </>
            )}
          </Box>
          
          <Box
            sx={{
              backgroundColor: `${color}15`,
              borderRadius: '50%',
              p: 1.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Icon sx={{ color, fontSize: '1.5rem' }} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MetricCard;